// src/components/DYPLicensedUser/DYPLicensedUserShared.js

import { normalizeUrl } from "../../utils/urlUtils";

/**
 * Generates embed code for the DYP Licensed User Block based on configuration
 *
 * @param {Object} config - Configuration object for the DYP Licensed User Block
 * @returns {string} HTML script tag with data attributes
 */
export const generateDYPLicensedUserEmbedCode = (config) => {
    const {
      backgroundColor = "#1e3553",
      textColor = "#ffffff",
      accentColor = "#d5ad36",
      headingFont = "serif",
      bodyFont = "sans-serif",
      buttonText,
      buttonRadius = 4,
      organizationName,
      buttonUrl = "#",
      logoUrl = "https://tpci.vercel.app/dyp_logo.png",
      companyAcronym = "PHCG"
    } = config || {};

    // Use dynamic values
    const dynamicButtonText = buttonText || `Contact ${companyAcronym}`;
    const dynamicOrgName = organizationName || companyAcronym;

    // Normalize button URL to ensure it has https://
    const normalizedButtonUrl = normalizeUrl(buttonUrl);

    return `<script
    src="https://tpci.vercel.app/embed/dyp-licensed-user-section.js"
    data-background="${backgroundColor}"
    data-text-color="${textColor}"
    data-accent-color="${accentColor}"
    data-heading-font="${headingFont}"
    data-body-font="${bodyFont}"
    data-button-text="${dynamicButtonText}"
    data-button-radius="${buttonRadius}"
    data-organization-name="${dynamicOrgName}"
    data-button-url="${normalizedButtonUrl}"
    data-logo-url="${logoUrl}">
  </script>`;
  };